function setupScreenSize() {
}

export default { setupScreenSize };
